export default __webpack_public_path__ + "static/media/alphabet-yellow-g.39cc12a8.png";